import React from "react";
import {useNavigate} from "react-router-dom";
import pispFigure from "/assets/pisp-figure.svg?url"
import HeaderItem from "../../components/headerItem/HeaderItem";
import FeatureKey from "../../components/featureKey/FeatureKey";
import {FeatureContainer, FeatureGrid, FeatureKeyTitle} from "../../components/featureKey/FeatureKey.css";
import StoreItem from "../../components/storeItem/StoreItem";
import cardLogo from "/assets/api-card-logo.svg?url"
import oauth2Logo from "/assets/api-oauth2-logo.svg?url"
import {Recommended, SeeAlsoText} from "../../global.css";
import {UseCaseContainer, UseCaseIntro, UseCaseTitle} from "../../components/UseCaseItem/UseCaseItem.css";
import UseCaseItem from "../../components/UseCaseItem/UseCaseItem";
import ScrollToTop from "../../hooks/scrollToTop";

function Pisp() {
    const navigate = useNavigate()
    return (
        <div>
            <HeaderItem title={"PISP"}
                        description={"L'API PISP (Payment Initiation Service Provider), permet à des tiers, tels que des fournisseurs de services de paiement ou des applications, d'initier des paiements en ligne au nom d'un utilisateur. Cette API est une composante clé de la Directive sur les services de paiement 2 (DSP2) de l'Union européenne, qui vise à ouvrir le marché des paiements en ligne, à améliorer la sécurité des transactions et à encourager l'innovation dans le secteur des services financiers."}
                        imageUrl={pispFigure}
                        onClick={() => navigate("/pisp/documentation")}>
            </HeaderItem>

            <div className={FeatureKeyTitle}>Fonctionnalités Clés</div>

            <div className={FeatureContainer}>
                <div className={FeatureGrid}>
                    <FeatureKey title={"1"} description1={"Initiation"} description2={"de Paiement"}></FeatureKey>
                    <FeatureKey title={"2"} description1={"Authentification Renforcée"} description2={"du Client (SCA)"}></FeatureKey>
                    <FeatureKey title={"3"} description1={"Accès aux Informations"} description2={"de Compte (AIS)"}></FeatureKey>
                    <FeatureKey title={"4"} description1={"Gestion"} description2={"des Consentements Utilisateur"}></FeatureKey>
                    <FeatureKey title={"5"} description1={"Confirmation"} description2={"de Paiement"}></FeatureKey>
                    <FeatureKey title={"6"} description1={"Compatibilité"} description2={"Multi-canal"}></FeatureKey>
                </div>



                <div className={UseCaseContainer}>
                    <div className={UseCaseTitle}>Cas d'utilisation</div>
                    <p className={UseCaseIntro}>
                        Les fournisseurs de services financiers tiers peuvent l'utiliser pour offrir de la valeur ajoutée aux utilisateurs.
                        <br/>
                        Voici quelques cas d'utilisation courants de l'API AISP :
                    </p>
                    <UseCaseItem
                        number="1"
                        title="Agrégation de Comptes Financiers :"
                        description="Les agrégateurs financiers utilisent l'API AISP pour rassembler les informations de compte de différents fournisseurs de services financiers (banques, cartes de crédit, comptes d'investissement, etc.) dans une seule application ou plateforme. Cela permet aux utilisateurs de visualiser l'ensemble de leurs finances en un seul endroit, offrant une vue consolidée de leurs avoirs et de leurs transactions."
                    />
                    <UseCaseItem
                        number="2"
                        title="Gestion Budgétaire et Suivi des Dépenses :"
                        description="Les applications de gestion financière utilisent l'API AISP pour analyser les habitudes de dépenses des utilisateurs en accédant à leurs informations de compte. Cela permet aux utilisateurs de suivre leurs dépenses, de créer des budgets personnalisés et de recevoir des alertes en cas de dépassement budgétaire. Cette fonctionnalité aide les utilisateurs à gérer efficacement leurs finances et à prendre des décisions éclairées en matière de dépenses."
                    />
                    <UseCaseItem
                        number="3"
                        title="Conseils Financiers Personnalisés :"
                        description="Les fournisseurs de services financiers peuvent utiliser l'API AISP pour analyser les données financières des utilisateurs et leur fournir des conseils personnalisés en fonction de leur situation financière. Cela peut inclure des recommandations d'épargne, d'investissement, de réduction de dettes, etc. Ces conseils personnalisés aident les utilisateurs à atteindre leurs objectifs financiers et à améliorer leur bien-être financier."
                    />
                    <UseCaseItem
                        number="4"
                        title="Évaluation du Risque de Crédit :"
                        description="Les fournisseurs de services de prêt utilisent l'API AISP pour évaluer la solvabilité des emprunteurs potentiels en analysant leurs données financières. Cela leur permet de prendre des décisions de crédit plus éclairées en évaluant la capacité de remboursement des emprunteurs et en réduisant les risques de défaut de paiement."
                    />
                    <UseCaseItem
                        number="5"
                        title="Développement de Produits Financiers Innovants :"
                        description="Les institutions financières et les startups utilisent l'API AISP pour développer de nouveaux produits et services financiers innovants en s'appuyant sur les données financières des utilisateurs. Cela peut inclure des offres de crédit basées sur le comportement financier des utilisateurs, des produits d'épargne automatisés, etc."
                    />
                </div>


                <div className={SeeAlsoText}>Nous vous recommandons aussi....</div>
                <div className={Recommended}>
                    <StoreItem
                        title={"AISP"}
                        description={"Prestataires de services d’information sur les comptes"}
                        onClick={() => navigate("/aisp")}
                        imageUrl={cardLogo}>
                    </StoreItem>
                    <StoreItem
                        title={"OAuth2"}
                        description={"Protocole d'autorisation à accès limité aux ressources utilisateur"}
                        onClick={() =>navigate("/oauth2")}
                        imageUrl={oauth2Logo}>
                    </StoreItem>
                </div>
            </div>
            <ScrollToTop />
        </div>
    );
}

export default Pisp;